module.exports = __webpack_public_path__ + "img/hohlsaum_rot_candy.164f3b28.jpg";